exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".set-rating__wrapper-KEobJe{display:flex;position:relative}[type='radio'].svelte-eh3d91{margin:0 -1px 0 0;width:12px;height:20px;opacity:0;border:0;position:absolute;top:-1rem}.set-rating__wrapper-KEobJe .star-111140+.star-111140{margin-left:5px}", ""]);
